import system from '@/http/modules/system'
const state = () => ({
  systemConfigFromStore: {}
})

const getters = {}

// 系统设置
const actions = {
    getSystemConfigAction({ commit }) {
        return new Promise(resolve => {
          system.getConfigData().then(({data}) => {
            commit('setSystemConfig', data)
            resolve(data)
          })
        })
    }
}

const mutations = {
    setSystemConfig(state, data) {
        state.systemConfigFromStore = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}